module.exports = __webpack_public_path__ + "static_pc/img/4.984ba460.jpg";